/**
 * @file slider
 *
 * @module slider
 *
 */

//import $ from 'jquery';

/* global $, console */
(function($) {
  'use strict';

  var config = {
    carousel    : '.fpi-carousel .owl-carousel',
    mainBtn     : '.fpi-carousel-controls-btn',
    playBtn     : '.fpi-carousel-controls-btn--play',
    pauseBtn    : '.fpi-carousel-controls-btn--pause',
    dotBtn      : '.owl-dot',
    progressBar : '.fpi-carousel-progressBar',
  };

  /**
   * Extend the slider object with functions responsible for the slider behaviors
   * @memberof module:slider
   */

  function carousel() {
    $(config.carousel).owlCarousel({
      items: 1,
      autoplay: true,
      autoplaySpeed: 1000,
      loop: true,
      onInitialized: startProgressBar,
      onTranslate: resetProgressBar,
      onTranslated: startProgressBar,
      responsive: {
        0:{
          nav: true,
          dots: false,
          navContainer: '.owl-nav',
        },
        1022:{
          nav: false,
          dots: true,
          dotsData: true,
          dotsContainer: '.fpi-carousel-controls .dots',
          touchDrag: false,
          mouseDrag: false,
        },
      },
    });
  }

  function startProgressBar() {
    $(config.progressBar).css({
      width: "100%",
      transition: "width 5000ms",
    });
  }

  function resetProgressBar() {
    $(config.progressBar).css({
      width: 0,
      transition: "width 0s",
    });
  }

  function checkBtn() {
    $(config.mainBtn).on('click',function(){
      if ($(config.mainBtn).hasClass('fpi-carousel-controls-btn--pause')) {
        $(config.carousel).trigger('stop.owl.autoplay');
        $(config.mainBtn).removeClass('fpi-carousel-controls-btn--pause');
        $(config.mainBtn).addClass('fpi-carousel-controls-btn--play');

      } else {
        $(config.carousel).trigger('play.owl.autoplay');
        $(config.mainBtn).removeClass('fpi-carousel-controls-btn--play');
        $(config.mainBtn).addClass('fpi-carousel-controls-btn--pause');
      }
    });
  }

  function checkDots() {
    $(config.dotBtn).on('click',function(){
      $(config.carousel).trigger('to.owl.carousel', [$(this).index(), 1000]);
    });
  }

  // init
  $(document).ready(function() {
    carousel();
    checkBtn();
    checkDots();
  });

})(jQuery);



// WEBPACK FOOTER //
// ./src/js/modules/carousel.js